"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/Flight.tsx
function Flight(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    fillRule: "evenodd",
    d: "M18.941 1.989c.822-.08 1.617.154 2.266.804.695.695.858 1.564.726 2.395-.123.782-.508 1.566-.95 2.283-.663 1.072-1.611 2.22-2.443 3.226l-.357.433 3.711 7.423a1 1 0 01-.187 1.154l-2 2a1 1 0 01-1.385.028l-5.847-5.397-2.614 2.241-.912 2.737A1 1 0 018 22H6a1 1 0 01-.894-.553l-.851-1.702-1.702-.85A1 1 0 012 18v-2a1 1 0 01.684-.949l2.737-.912 2.24-2.614-5.396-5.847a1 1 0 01.028-1.385l2-2a1 1 0 011.154-.187l7.413 3.706.282-.238c1.211-1.022 2.456-2.073 3.587-2.751.694-.416 1.448-.759 2.212-.834zm-4.454 5.068c-.276.233-.558.47-.847.711a1 1 0 01-1.087.126L5.197 4.217l-.81.81 5.348 5.795a1 1 0 01.024 1.329l-3 3.5a1 1 0 01-.443.298L4 16.72v.661l1.447.724a1 1 0 01.447.447L6.618 20h.661l.772-2.316a1 1 0 01.298-.443l3.5-3a1 1 0 011.33.024l5.793 5.348.811-.81-3.677-7.356a1 1 0 01.113-1.072c.278-.347.567-.697.857-1.048.809-.98 1.621-1.963 2.206-2.908.393-.636.614-1.152.676-1.544.054-.343-.017-.52-.165-.668-.194-.193-.383-.255-.656-.228-.332.033-.785.202-1.38.559-.978.587-2.063 1.501-3.27 2.52z",
    clipRule: "evenodd"
  }));
}
var Flight_default = Flight;

exports.Flight_default = Flight_default;
